export default __webpack_public_path__ + "static/media/fiolet_block.4cc790db.svg";